import { useTranslation } from '@dreamstack/i18n'
import { ArrowRight } from '@dreamstack/icons/src/icon-components/ArrowRight'
import { cn } from '@dreamstack/util/src/cn'
import { motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import {
  AnimateIconTranslationRight,
  useAnimateIconTranslationRight,
} from '../../layout/AnimateIconTranslation'
import { GridWithGaps } from '../../layout/MainGrid'
import { SimpleMuiButton } from '../../layout/SimpleMuiButton'
import { HeadingH3 } from '../../layout/Texts'
import { useProjectBaseUrl } from '../../projects/helper/useProjectBaseUrl'

const ImageSrc = '/static/images/project-teaser.png'
// 'https://images.unsplash.com/photo-1505843513577-22bb7d21e455?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1490&q=80'

const PropertyIndexResultAreaInnerGrid = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <GridWithGaps
    className={cn('grid-cols-12 md:grid-cols-8 lg:grid-cols-9', className)}
    {...rest}
  >
    {children}
  </GridWithGaps>
)

const PositionContainer = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <div
    className={cn(
      'col-start-1 col-span-12 md:col-start-2 md:col-span-7',
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

export const PropertyFilterProjectLink: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const { onHoverStart, controls } = useAnimateIconTranslationRight()
  const t = useTranslation()
  const href = useProjectBaseUrl()
  return (
    <PropertyIndexResultAreaInnerGrid>
      <PositionContainer>
        <div className="flex flex-col space-y-px-12 md:flex-row md:space-y-0 md:space-x-px-32">
          <div className="h-px-96 w-px-96 relative md:self-center">
            <Image
              className="object-cover"
              fill
              src={ImageSrc}
              alt={'project teaser image'}
            />
          </div>
          <div className="flex flex-col md:justify-center">
            <HeadingH3>{t('accentro:projectLinkSection.title')}</HeadingH3>
            <Link href={href} passHref legacyBehavior>
              <motion.a onHoverStart={onHoverStart}>
                <SimpleMuiButton
                  variant="text"
                  color="primary"
                  endIcon={
                    <AnimateIconTranslationRight animate={controls}>
                      <ArrowRight />
                    </AnimateIconTranslationRight>
                  }
                >
                  <span className="text-left">
                    {t('accentro:projectLinkSection.linkLabel')}
                  </span>
                </SimpleMuiButton>
              </motion.a>
            </Link>
          </div>
        </div>
      </PositionContainer>
    </PropertyIndexResultAreaInnerGrid>
  )
}
